import { useState, useEffect } from 'react';

const useApproximateProgress = (durationSeconds: number, createdAt?: string | null) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    let interval: ReturnType<typeof setInterval>;
    const startTime = createdAt ? new Date(createdAt).getTime() : Date.now();
    const duration = durationSeconds * 1000;

    const updateProgress = () => {
      const elapsedTime = Date.now() - startTime;
      const newProgress = Math.min(Math.floor((elapsedTime / duration) * 99), 99);
      setProgress(newProgress);

      if (newProgress === 99) {
        clearInterval(interval);
      }
    };

    updateProgress();
    interval = setInterval(updateProgress, 1000);

    return () => {
      if (interval) clearInterval(interval);
    };
  }, [durationSeconds, createdAt]);

  return progress;
};

export default useApproximateProgress;
